module.exports = "/static/assets/6cd3d9e09b16222b242f5e2d77f8a62a.png";